/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Media_Import_CompleteInputs */

const en_team_project_import_media_import_complete = /** @type {(inputs: Team_Project_Import_Media_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media import completed successfully.`)
};

const fr_team_project_import_media_import_complete = /** @type {(inputs: Team_Project_Import_Media_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation du média terminée avec succès.`)
};

const de_team_project_import_media_import_complete = /** @type {(inputs: Team_Project_Import_Media_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medienimport erfolgreich abgeschlossen.`)
};

const it_team_project_import_media_import_complete = /** @type {(inputs: Team_Project_Import_Media_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione dei media completata con successo.`)
};

const ru_team_project_import_media_import_complete = /** @type {(inputs: Team_Project_Import_Media_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт медиафайлов успешно завершен.`)
};

const es_team_project_import_media_import_complete = /** @type {(inputs: Team_Project_Import_Media_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La importación de medios se completó correctamente.`)
};

const zh_cn2_team_project_import_media_import_complete = /** @type {(inputs: Team_Project_Import_Media_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体导入成功完成。`)
};

const ja_team_project_import_media_import_complete = /** @type {(inputs: Team_Project_Import_Media_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアのインポートが正常に完了しました。`)
};

const hi_team_project_import_media_import_complete = /** @type {(inputs: Team_Project_Import_Media_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया का आयात सफलतापूर्वक पूरा हो गया।`)
};

const pt_pt2_team_project_import_media_import_complete = /** @type {(inputs: Team_Project_Import_Media_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação de mídia concluída com sucesso.`)
};

/**
* | output |
* | --- |
* | "Media import completed successfully." |
*
* @param {Team_Project_Import_Media_Import_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_media_import_complete = /** @type {((inputs?: Team_Project_Import_Media_Import_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Media_Import_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_project_import_media_import_complete(inputs)
	if (locale === "de") return de_team_project_import_media_import_complete(inputs)
	if (locale === "it") return it_team_project_import_media_import_complete(inputs)
	if (locale === "ru") return ru_team_project_import_media_import_complete(inputs)
	if (locale === "es") return es_team_project_import_media_import_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_team_project_import_media_import_complete(inputs)
	if (locale === "ja") return ja_team_project_import_media_import_complete(inputs)
	if (locale === "hi") return hi_team_project_import_media_import_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_team_project_import_media_import_complete(inputs)
	return en_team_project_import_media_import_complete(inputs)
});